const MAX_WIDTH = 1080
const MAX_HEIGHT = 1920
const MAX_FILE_SIZE_BYTES = 1 * 1024 * 1024
const INITIAL_QUALITY = 0.95
const MIN_QUALITY = 0.5
const QUALITY_STEP = 0.05

const loadImage = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (e) => {
      const img = new Image()

      img.onload = () => resolve(img)
      img.onerror = reject
      img.src = e.target.result
    }

    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

const resizeImage = (img, maxWidth, maxHeight) => {
  const canvas = document.createElement('canvas')
  let {width, height} = img

  const widthRatio = maxWidth / width
  const heightRatio = maxHeight / height
  const ratio = Math.min(widthRatio, heightRatio, 1)

  width = Math.round(width * ratio)
  height = Math.round(height * ratio)

  canvas.width = width
  canvas.height = height

  const ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, width, height)

  return canvas
}

const canvasToBlob = (canvas, quality) => {
  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => resolve(blob),
      'image/jpeg',
      quality
    )
  })
}

export const optimizeImage = async (file) => {
  const img = await loadImage(file)

  const canvas = resizeImage(img, MAX_WIDTH, MAX_HEIGHT)

  let quality = INITIAL_QUALITY
  let optimizedBlob = await canvasToBlob(canvas, quality)

  while (optimizedBlob.size > MAX_FILE_SIZE_BYTES && quality > MIN_QUALITY) {
    quality -= QUALITY_STEP
    optimizedBlob = await canvasToBlob(canvas, quality)
  }

  if (optimizedBlob.size > MAX_FILE_SIZE_BYTES) {
    throw new Error(`Unable to compress image below ${MAX_FILE_SIZE_BYTES / (1024 * 1024)}MB`)
  }

  const originalExtension = file.name.split('.').pop()
  const nameWithoutExtension = file.name.replace(`.${originalExtension}`, '')
  const optimizedFileName = `${nameWithoutExtension}.jpg`

  return new File([optimizedBlob], optimizedFileName, {
    type: 'image/jpeg',
    lastModified: Date.now()
  })
}
